.mainScreenTopDiv{
    display: flex;
    flex-direction: column;
    height: calc(100dvh - var(--pwa-navigation-height, 0px));
}

.agendaColumnBASE {
    margin-top: 52px;
    overflow: auto;
}

.agendaColumnFull {
    composes: agendaColumnBASE;
    flex-grow: 1;
}

.agendaColumnReduced {
    composes: agendaColumnBASE;
}

.patientEdit{
    display: flex;
}



.bottomDrawer {
    background-color: white;
    width: 100%;
    flex-basis: auto;
    border-color: var(--color-gray-200);
    border-top-style: solid;
    border-top-width: 2px;
}
